module.exports = __webpack_public_path__ + "img/stock5.ac759596.png";